<template>
  <button class="btn btn-filter" type="button" @click="openFilter" v-hover="onHoverOverFilterButton">
    <FilterIcon/>
  </button>

  <HoverInfo :show="hoveringOverFilterButton" :content="'Filter'" :offset-y="12" :offset-x="12"></HoverInfo>

  <teleport to="body">
    <div v-if="filterOpen" class="filter-view">
      <div class="filter-container">
        <div class="filter-header">
          <h3>Filter</h3>
          <div class="filter-header__right">
            <div class="active-filters" v-if="selectedFiltersCount > 0">
              {{ selectedFiltersCount }} {{ selectedFiltersCount === 1 ? 'filter' : 'filters' }} actief
            </div>
            <button class="btn btn-reset-filter" type="button" @click="resetFilters">
              <FilterResetIcon/>
            </button>
          </div>
        </div>

        <div class="filter-categories mt-2">
          <slot></slot>
        </div>

        <div class="filter-footer mt-3">
          <button class="btn btn-sandpiper btn-block apply-btn" @click="applyFilter">Filteren</button>
          <button class="btn btn-link mt-3 cancel-btn" @click="cancelFilter">Annuleren</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import HoverInfo from "@/components/UI/HoverInfo.vue";
import FilterIcon from "@/assets/image/icons/filter/icon-filter.svg?inline";
import FilterResetIcon from "@/assets/image/icons/filter/icon-reset.svg?inline";

export default {
  name: "Filter",
  components: { HoverInfo, FilterIcon, FilterResetIcon },
  props: {
    filterCategories: Array,
    selectedFiltersCount: Number,
    loading: Boolean
  },
  emits: [ "filter-opened", "filter-cancelled", "filter-reset", "filter-updated" ],
  data()
  {
    return {
      filterOpen: false,
      hoveringOverFilterButton: false
    }
  },
  methods: {
    openFilter()
    {
      this.filterOpen = true;
      this.$emit("filter-opened");
    },
    cancelFilter()
    {
      this.filterOpen = false;
      this.$emit("filter-cancelled");
    },
    resetFilters()
    {
      this.filterOpen = false;
      this.$emit("filter-reset");
    },
    applyFilter()
    {
      this.filterOpen = false;
      this.$emit("filter-updated");
    },
    onHoverOverFilterButton(state) {
      this.hoveringOverFilterButton = state;
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-filter,
.btn-reset-filter
{
  background-color: $primary-blue;
  color: $font-light;
  padding: 10px;

  svg
  {
    fill: $font-light;
    max-width: 23px;
    max-height: 23px;
  }
}

.filter-view
{
  color: $font-light;

  z-index: 999;

  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;

  &::before
  {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: $primary-background-dark;
    opacity: 0.9;
  }
}

.filter-container
{
  position: relative;

  max-width: 430px;
  width: 100%;
  margin: 30px auto;
  padding: 0 15px;

  overflow-y: auto;
}

.filter-header
{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  h3
  {
    color: $font-light;
    font-size: 1.2rem;
  }

  .filter-header__right
  {

  }

  .active-filters
  {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.filter-footer
{
  text-align: center;
}

.apply-btn
{

}

.cancel-btn
{
  color: $font-light;
}
</style>